<template>
  <div class="w-full">
    <b-row>
      <b-modal ref="rollbackModal" title="Rollback Registered Company" size="md" hide-footer>
        <b-col class="mx-auto">
          <form @submit.prevent="submitRollback">
            <div class="form-group">
              <label class="text-xs font-bold text-gray">BRN</label>
              <b-form-input class="text-sm my-1 font-bold" :disabled="true" v-model="rollbackBrn"/>
            </div>
            <div class="form-group mt-2">
              <label class="text-xs font-bold text-gray">Reason</label>
              <b-form-select
                v-model="rollbackReason"
                class="form-select noFocus text-gray text-sm my-1"
                required>
                <b-select-option :value="null">--Select reason--</b-select-option>
                <b-select-option value="CHANGE_OF_NAME">Change of Name</b-select-option>
                <b-select-option value="INVALID_DIRECTORSHIP">Invalid Directorship</b-select-option>
              </b-form-select>
            </div>
            <div class="form-group mt-2">
              <label class="text-xs font-bold text-gray">Rationale</label>
              <b-form-textarea
                class="text-sm my-1"
                placeholder="Enter rationale..."
                v-model="rollbackRationale"
                rows="4"
                maxlength="300"
                required />
              <p class="my-1 text-xs text-gray">{{ rollbackRationale.length }}/300</p>
            </div>
            <button class="mt-3 w-full bg-red px-2 py-1 rounded-sm text-white" type="submit" :disabled="loadingRollback">
              Rollback <b-spinner v-if="loadingRollback" small></b-spinner>
            </button>
          </form>
        </b-col>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2">
        <b-row>
          <b-col cols="3">
            <b-form-input
              class="text-gray text-sm noFocus ml-1"
              style="margin-top: 1px; padding:6px 5px;"
              v-model="search"
              type="text"
              placeholder="Search by Name or BRN"
              required
              v-on:keyup.enter="fetch">
            </b-form-input>
          </b-col>
          <b-col cols="3">
            <b-form-select
              class="form-select text-sm noFocus text-gray"
              v-model="subType"
              v-on:change="fetch">
              <b-select-option :value="null">--Filter by Type--</b-select-option>
              <b-select-option value="private-company-limited-by-shares">Private Limited by Shares</b-select-option>
              <b-select-option value="single-member-company">Single Member Company</b-select-option>
              <b-select-option value="private-company-limited-by-guarantee-with-shares">Private Limited by Guarantee with Share capital</b-select-option>
              <b-select-option value="private-company-limited-by-guarantee-without-shares">Private Limited by Guarantee without Share capital</b-select-option>
              <b-select-option value="public-company">Public Company</b-select-option>
              <b-select-option value="unlimited-company">Unlimited Company</b-select-option>
              <b-select-option value="foreign-company">Foreign Company</b-select-option>

            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-form-select
              class="form-select text-sm noFocus text-gray"
              v-model="status"
              v-on:change="fetch">
              <b-select-option :value="null">--Filter by Status--</b-select-option>
              <b-select-option value="Registered">Registered</b-select-option>
              <b-select-option value="Compliant">Compliant</b-select-option>
              <b-select-option value="Dormant">Dormant</b-select-option>
              <b-select-option value="DISSOLVED">Dissolved</b-select-option>
              <b-select-option value="In_Liquidation">In Liquidation</b-select-option>
              <b-select-option value="Rolled_Back">Rolled Back</b-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="1">
            <b-form-select v-model="limit" class="w-full text-xs paginate-details mt-1" v-on:change="fetch">
              <b-select-option value="15">15</b-select-option>
              <b-select-option value="20">20</b-select-option>
              <b-select-option value="50">50</b-select-option>
              <b-select-option value="100">100</b-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-row>
              <b-col class="mx-auto">
                <p class="paginate-details text-center text-xs font-bold">
                  <span>{{((currentPage - 1) * limit) + 1}}</span> -
                  <span v-if="limit > entities.length ">{{pagination.totalElements}}</span>
                  <span v-else>{{currentPage * limit}}</span>
                  of {{pagination.totalElements}}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mx-1 my-1">

          <b-col cols="3">
            <b-form-group label="Date approved from" label-for="date-input" class="mb-0">
              <b-form-input
                class="text-gray text-sm noFocus ml-1"
                style="margin-top: 1px; padding:6px 5px;"
                v-model="startDate"
                type="date"
                required
                v-on:change="fetch">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Date approved to" label-for="date-input" class="mb-0">
              <b-form-input
                class="text-gray text-sm noFocus"
                style="margin-top: 1px; padding:6px 5px;"
                v-model="endDate"
                type="date"
                required
                v-on:change="fetch">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="3">
            <b-form-group label="Date registered from" label-for="date-input" class="mb-0">
              <b-form-input
                class="text-gray text-sm noFocus ml-1"
                style="margin-top: 1px; padding:6px 5px;"
                v-model="startRegistrationDate"
                type="date"
                required
                v-on:change="fetch">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Date registered to" label-for="date-input" class="mb-0">
              <b-form-input
                class="text-gray text-sm noFocus"
                style="margin-top: 1px; padding:6px 5px;"
                v-model="endRegistrationDate"
                type="date"
                required
                v-on:change="fetch">
              </b-form-input>
            </b-form-group>
          </b-col>

        </b-row>
      </b-col>
    </b-row>
    <div class="mx-auto">
      <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
    </div>
    <b-row>
      <b-col cols="12">
        <table class="min-w-full leading-normal">
          <thead>
          <tr class="border-b border-t border-grey">
            <th class="t-header">#</th>
            <th class="t-header">BRN</th>
            <th class="t-header">Name</th>
            <th class="t-header">Sub Type</th>
            <th class="t-header">TIN</th>
            <th class="t-header text-center">Reg. Date</th>
            <th class="t-header text-center">Status</th>
            <th class="t-header text-center">Action</th>
          </tr>
          </thead>

          <tbody>
          <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(entity, idx) in entities" :key="idx">
            <td class="t-body">{{(currentPage - 1) * limit + idx + 1}}</td>
            <td class="t-body text-blue font-bold" >
              <span class="hover:text-blue-dark cursor-pointer underline" @click="viewFile(entity)">{{entity.brn}}</span>
            </td>
            <td class="t-body font-bold">
              {{entity.name}}
            </td>
            <td class="t-body text-capitalize">
              {{cleanEntityType(entity.subEntityType)}}
            </td>
            <td class="t-body">
              <span v-if="entity.tin">{{entity.tin}}</span>
              <span v-else>Not filed yet</span>
            </td>
            <td class="t-body text-center">
              {{dateFormat(entity.registrationDate)}}
            </td>
            <td class="t-body text-center">
              <span :class="getStatusStyling(entity.status)">{{  entity.status === 'WALID' ? 'Registered' : entity.status}}</span>
            </td>
            <td class="text-center">
              <button class="bg-blue text-white rounded-sm px-2 py-1 text-xs hover:bg-blue-dark" @click="viewFile(entity)">View</button>
              <button
                v-if="canViewActionWithPermission('can_rollback_company_application') && entity.brn && String(entity.brn).startsWith('800') && (entity.status === 'WALID' || String(entity.status).toUpperCase() === 'REGISTERED')"
                class="bg-red text-white rounded-sm px-2 py-1 text-xs hover:bg-red-dark ml-1"
                @click="rollbackPrompt(entity)">
                <i class="fa fa-undo mx-1"></i>Rollback
              </button>
            </td>
          </tr>
          <tr>
            <td v-if="entities.length === 0" colspan="8" class="bg-inertgrey text-center py-1">
              <span class="text-sm">No results found</span>
            </td>
          </tr>
          <tr>
            <td v-if="hasError" colspan="12" class="bg-red text-center py-1 text-white">
              <p class="text-sm">Failed to load tasks, Try again later.</p>
              <p class="text-sm">{{errorMessage}}</p>
              <p class="text-sm">
                <button class="bg-white text-red px-2 rounded-sm" @click="fetch">Reload <b-spinner v-if="loading" small></b-spinner></button>
              </p>
            </td>
          </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <b-row class="mx-1" v-if="pagination.totalPages > 1">
      <b-col cols="1">
        <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
      </b-col>
      <b-col cols="1">
        <b-row>
          <b-col cols="12">
            <p class="paginate-details text-center">
              <b-badge class="bg-blue text-white">
                {{(currentPage)}}/{{pagination.totalPages}}
              </b-badge>
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="1" >
        <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
      </b-col>
      <b-col cols="6"></b-col>
      <b-col cols="1">
        <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details" v-on:change="fetch">
          <b-select-option value="15">15</b-select-option>
          <b-select-option value="20">20</b-select-option>
          <b-select-option value="50">50</b-select-option>
          <b-select-option value="100">100</b-select-option>
        </b-form-select>
      </b-col>
      <b-col cols="2">
        <b-row>
          <b-col class="mx-auto">
            <p class="paginate-details text-center text-xs font-bold">
              <span>{{((currentPage - 1) * limit) + 1}}</span> -
              <span v-if="limit > entities.length ">{{pagination.totalElements}}</span>
              <span v-else>{{currentPage * limit}}</span>
              of {{pagination.totalElements}}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import router from "@/router";
import { api } from "@/app/services/api.service";

export default {
  name: "CompanyRegistry",
  data(){
    return{
      loading:false,
      currentPage:1,
      limit:15,
      entities:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
      search:"",
      subType:null,
      startDate:null,
      endDate:null,
      startRegistrationDate:null,
      endRegistrationDate:null,
      status:null,
      hasError:false,
      errorMessage:null,
      loadingRollback:false,
      rollbackBrn:"",
      rollbackReason:null,
      rollbackRationale:"",
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["fetchCompanyRegistry"]),
    fetch(){
      let data = {
        search:this.search,
        subType:this.subType,
        startDate:this.dateRangeFormat(this.startDate),
        endDate:this.dateRangeFormat(this.endDate),
        startRegistrationDate: this.startRegistrationDate ? moment(this.startRegistrationDate).format('YYYY-MM-DD') : null,
        endRegistrationDate: this.endRegistrationDate ? moment(this.endRegistrationDate).format('YYYY-MM-DD') : null,
        status:this.status,
        page:this.currentPage,
        limit:this.limit,
      }
      this.loading = true
      this.hasError = false
      this.fetchCompanyRegistry(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    getStatusStyling(status){
      if(status === "Registered" || status === "Amalgamated" || status === "Compliant"){
        return "text-green"
      }else if(status === "In_Liquidation"){
        return "text-green"
      }else{
        return "text-red"
      }
    },
    viewFile(data){
      if(data.status === "WALID"){
        this.errorToast("Error", "No results found")
      } else {
        data.type = "company"
        data.subType = data.subEntityType
        localStorage.setItem("registryEntity", JSON.stringify(data))
        router.push("/home/registry/business/file-viewer/" + data.brn)
        router.go(0)
      }


    },
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    canViewActionWithPermission(permission) {
      return this.$can(permission, "general") === true
    },
    rollbackPrompt(entity) {
      this.rollbackBrn = entity.brn
      this.rollbackReason = null
      this.rollbackRationale = ""
      this.$refs.rollbackModal.show()
    },
    submitRollback() {
      if (!this.rollbackReason) {
        this.errorToast("Error", "Please select a rollback reason")
        return
      }
      if (!this.rollbackRationale || !this.rollbackRationale.trim()) {
        this.errorToast("Error", "Please enter a rationale")
        return
      }
      this.loadingRollback = true
      api().post("/incorporation/registry/rollback", {
        brn: this.rollbackBrn,
        reason: this.rollbackReason,
        rationale: this.rollbackRationale.trim(),
      })
        .then(() => {
          this.loadingRollback = false
          this.$refs.rollbackModal.hide()
          this.successToast("Success", "Company rolled back successfully")
          this.fetch()
        })
        .catch(error => {
          this.loadingRollback = false
          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Failed to rollback company"
          this.errorToast("Error", message)
        })
    },
  },
  computed:{
    ...mapGetters(["getCompanyRegistry", "getRegistryError"])
  },
  watch:{
    getCompanyRegistry(data){
      this.loading = false
      this.entities = data.content
      this.pagination = {
        totalPages:data.totalPages,
        totalElements:data.totalElements
      }
    },
    getRegistryError(data){
      this.loading = false
      this.hasError = true
      this.errorMessage = data.message
    }
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.verified{
  @apply text-xs font-bold;
  color: green;
  font-style: italic;
}

.unverified{
  @apply text-xs font-bold;
  color: #b80404;
  font-style: italic;
}

.assign-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs w-full;
}

.assign-btn:hover{
  @apply bg-green text-white;
}

.de-assign-btn{
  @apply px-3 py-1 bg-white border-2 border-red text-red font-bold text-xs w-full;
}

.de-assign-btn:hover{
  @apply bg-red text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>